import * as Yup from 'yup';
import { DictionaryNace } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryNace>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
